import React from "react";
import { Link } from "react-router-dom";

import { Button } from "semantic-ui-react";
import { Container } from "./styles";

function Card({ id, nome, img, remove }) {
  return (
    <Container>
      <header>
        <p>ID: {id}</p>
      </header>
      <main>
        <img src={img} alt="Imagem do corpo" />
        <div>{nome}</div>
      </main>
      <footer>
        <Link to={`/admin/bandeiras_cart/${id}`}>
          <Button color="secondary">Editar</Button>
        </Link>
        <Button color="red" onClick={() => remove(nome, id)}>
          Excluir
        </Button>
      </footer>
    </Container>
  );
}

export default Card;
